import Vue, { getCurrentInstance } from 'vue';
import Vuetify from 'vuetify/lib';
// @ts-expect-error No declaration file found
import sv from 'vuetify/es5/locale/sv';
// @ts-expect-error No declaration file found
import en from 'vuetify/es5/locale/en';
// @ts-expect-error No declaration file found
import de from 'vuetify/es5/locale/de';
// @ts-expect-error No declaration file found
import nl from 'vuetify/es5/locale/nl';
// @ts-expect-error No declaration file found
import no from 'vuetify/es5/locale/no';
// @ts-expect-error No declaration file found
import da from 'vuetify/es5/locale/da';
import colors from 'vuetify/lib/util/colors';
Vue.use(Vuetify);
export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: colors.blueGrey.lighten1,
                secondary: '#21C2EC', /* Den blå färgen i CampingOnline loggan */
                /* #21c2ec RGB(33, 194, 236) secondary darken-2 */
                error: '#FF5252',
                success: '#4CAF50',
                warning: '#FB8C00'
            }
        }
    },
    lang: {
        locales: {
            sv, en, de, nl, no, da
        },
        current: 'sv'
    }
});
export const useVuetify = () => {
    const instance = getCurrentInstance();
    const vuetify = instance?.proxy?.$vuetify;
    if (!vuetify) {
        throw new Error('Vuetify not found in `useVuetify`');
    }
    return vuetify;
};
